import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../AdminPanel.css";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import { FaClock, FaDollarSign, FaMoneyBillWave, FaArrowRight } from "react-icons/fa";

const AdminPanel = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [notifications, setNotifications] = useState([
    { id: 1, message: "Create Estimate SKC-100264975", user: "Derick", time: "2 hrs ago", read: false },
    { id: 2, message: "Create Estimate SKC-100876532", user: "Derick", time: "2 hrs ago", read: false },
    { id: 3, message: "Update new Client GODFREY BORNFAIRM", user: "Super Admin", time: "3 hrs ago", read: false },
    { id: 4, message: "Stock New attachment NZE161-7093818 Inspection", user: "Waleed", time: "20 hrs ago", read: true },
    { id: 5, message: "Stock New attachment MA365-669610 Yard Pictures", user: "Waleed", time: "23 hrs ago", read: true },
  ]);

  useEffect(() => {
    const storedUserType = localStorage.getItem("usertype");

    if (!storedUserType) {
      navigate("/sign-in");
    } else {
      setUserType(storedUserType);
    }
  }, [navigate]);

  return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                {/* Use the new AdminNavbar component */}
                <AdminNavbar />
                
            <div className="main-content"> 

              <div className="main-section">
                <h3 className="section-title">Dashboard Overview</h3>

                {/* Stats Cards */}
                <div className="stats-grid">
                  <div className="stat-card">
                    <div className="stat-icon invoice-icon">
                      <FaDollarSign />
                    </div>
                    <div className="stat-info">
                      <span className="stat-amount">$0.00</span>
                      <span className="stat-label">Invoice Today</span>
                      <a href="#" className="stat-link">More info <FaArrowRight /></a>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon payment-icon">
                      <FaMoneyBillWave />
                    </div>
                    <div className="stat-info">
                      <span className="stat-amount">$0.00</span>
                      <span className="stat-label">Payment Today</span>
                      <a href="#" className="stat-link">More info <FaArrowRight /></a>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon income-icon">
                      <FaDollarSign />
                    </div>
                    <div className="stat-info">
                      <span className="stat-amount">$0.00</span>
                      <span className="stat-label">Income Today</span>
                      <a href="#" className="stat-link">More info <FaArrowRight /></a>
                    </div>
                  </div>

                  <div className="stat-card">
                    <div className="stat-icon expense-icon">
                      <FaDollarSign />
                    </div>
                    <div className="stat-info">
                      <span className="stat-amount">$0.00</span>
                      <span className="stat-label">Expense Today</span>
                      <a href="#" className="stat-link">More info <FaArrowRight /></a>
                    </div>
                  </div>
                </div>

                {/* Clock In & Summary Cards */}
                <div className="summary-grid">
                  <div className="summary-card clock-card">
                    <div className="clock-icon">
                      <FaClock />
                    </div>
                    <div className="clock-info">
                      <div className="clock-time">
                        {new Date().toLocaleDateString('en-US', { 
                          weekday: 'long', 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        })}
                      </div>
                      <div className="clock-label">Current Time</div>
                    </div>
                  </div>

                  <div className="summary-card total-income-card">
                    <div className="summary-amount">$0.00</div>
                    <div className="summary-label">Total Income</div>
                  </div>

                  <div className="summary-card total-expense-card">
                    <div className="summary-amount">$0.00</div>
                    <div className="summary-label">Total Expense</div>
                  </div>

                  <div className="summary-card more-info-card">
                    <div className="summary-amount">$0.00</div>
                    <div className="summary-label">More info</div>
                  </div>
                </div>

                {/* Recent Activities */}
                <div className="recent-activities">
                  <h4 className="table-title">Recent Activities</h4>
                  <div className="activity-list">
                    {notifications.map(activity => (
                      <div key={activity.id} className="activity-item">
                        <div className="activity-user">{activity.user}</div>
                        <div className="activity-time">{activity.time}</div>
                        <div className="activity-message">{activity.message}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Inventory Summary */}
                <div className="inventory-summary">
                  <h4 className="table-title">Inventory Summary</h4>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Total Vehicles</td>
                        <td>Coming Soon</td>
                      </tr>
                      <tr>
                        <td>Sold Vehicles</td>
                        <td>Coming Soon</td>
                      </tr>
                      <tr>
                        <td>Remaining Vehicles</td>
                        <td>Coming Soon</td>
                      </tr>
                      <tr>
                        <td>Total Sales Amount</td>
                        <td>Coming Soon</td>
                      </tr>
                      <tr>
                        <td>Remaining Stock Amount</td>
                        <td>Coming Soon</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default AdminPanel;